import { render, staticRenderFns } from "./LastObjectSettingForm.vue?vue&type=template&id=1767ffba&"
import script from "./LastObjectSettingForm.vue?vue&type=script&lang=js&"
export * from "./LastObjectSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports